import React, { useState } from 'react';
import emailjs from 'emailjs-com';
import './ContactForm.css';

const ContactForm = () => {
  const [formData, setFormData] = useState({
    name: '',
    mobileNumber: '',
    email: '',
    message: '',
    agreeToTerms: false
  });

  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState(null);

  // Handle input changes
  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData(prevState => ({
      ...prevState,
      [name]: type === 'checkbox' ? checked : value
    }));
  };

  // Handle form submission
  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    setSubmitStatus(null);

    // Validate checkbox
    if (!formData.agreeToTerms) {
      setSubmitStatus({
        type: 'error',
        message: 'Please agree to the terms and conditions'
      });
      setIsSubmitting(false);
      return;
    }

    try {
      // Send email using EmailJS
      const templateParams = {
        from_name: formData.name,
        from_email: formData.email,
        mobile_number: formData.mobileNumber,
        message: formData.message,
        to_email: 'deshmukhfaiz1212@gmail.com' // Replace with your email
      };

      const result = await emailjs.send(
        'service_9ml104b',      // Replace with your EmailJS service ID
        'template_kikoj85',     // Replace with your EmailJS template ID
        templateParams,
        '0xwHWtMSuQ8GHSdoq'          // Replace with your EmailJS user ID
      );

      if (result.status === 200) {
        setSubmitStatus({
          type: 'success',
          message: 'Form submitted successfully! We\'ll contact you soon.'
        });
        
        // Reset form
        setFormData({
          name: '',
          mobileNumber: '',
          email: '',
          message: '',
          agreeToTerms: false
        });
      }
    } catch (error) {
      setSubmitStatus({
        type: 'error',
        message: 'Something went wrong. Please try again.'
      });
      console.error('Email send error:', error);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="form-containerw">
      <h2 className="form-titlew">Contact Us</h2>
      
      <form onSubmit={handleSubmit} className="contact-formw">
        {/* Name Field */}
        <div className="form-groupw">
          <label htmlFor="name" className="form-labelw">
            Name <span className="required">*</span>
          </label>
          <input
            type="text"
            id="name"
            name="name"
            value={formData.name}
            onChange={handleChange}
            className="form-inputw"
            placeholder="Enter your full name"
            required
          />
        </div>

        {/* Mobile Number Field */}
        <div className="form-groupw">
          <label htmlFor="mobileNumber" className="form-labelw">
            Mobile Number <span className="required">*</span>
          </label>
          <input
            type="tel"
            id="mobileNumber"
            name="mobileNumber"
            value={formData.mobileNumber}
            onChange={handleChange}
            className="form-inputw"
            placeholder="Enter your mobile number"
            pattern="[0-9]{10}"
            title="Please enter a valid 10-digit mobile number"
            required
          />
        </div>

        {/* Email Field */}
        <div className="form-groupw">
          <label htmlFor="email" className="form-labelw">
            Email <span className="required">*</span>
          </label>
          <input
            type="email"
            id="email"
            name="email"
            value={formData.email}
            onChange={handleChange}
            className="form-inputw"
            placeholder="Enter your email address"
            required
          />
        </div>

        {/* Message Field */}
        <div className="form-groupw">
          <label htmlFor="message" className="form-labelw">
            Message <span className="required">*</span>
          </label>
          <textarea
            id="message"
            name="message"
            value={formData.message}
            onChange={handleChange}
            className="form-textareaw"
            placeholder="Enter your message"
            rows="5"
            required
          />
        </div>

        {/* Checkbox Field */}
        <div className="form-groupw checkbox-groupw">
          <input
            type="checkbox"
            id="agreeToTerms"
            name="agreeToTerms"
            checked={formData.agreeToTerms}
            onChange={handleChange}
            className="form-checkboxw"
          />
          <label htmlFor="agreeToTerms" className="checkbox-labelw">
            I signup to receive promotional notifications on SMS, mail and WhatsApp messages.<span className="required">*</span>
          </label>
        </div>

        {/* Submit Button */}
        <button 
          type="submit" 
          className={`submit-buttonw ${isSubmitting ? 'submitting' : ''}`}
          disabled={isSubmitting}
        >
          {isSubmitting ? 'Sending...' : 'Send Message'}
        </button>

        {/* Status Message */}
        {submitStatus && (
          <div className={`status-messagew ${submitStatus.type}`}>
            {submitStatus.message}
          </div>
        )}
      </form>
    </div>
  );
};

export default ContactForm;